/* import __COLOCATED_TEMPLATE__ from './external-editors.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
let ExternalEditors = (_class = class ExternalEditors extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isInsertingIfElseStatement", _descriptor, this);
    _initializerDefineProperty(this, "isEditingHtml", _descriptor2, this);
    _defineProperty(this, "trackAnalyticsEvent", (blockType, event = 'inserted') => {
      this.args.composer.config.analytics?.trackAnalyticsEvent(event, {
        block_type: blockType
      });
    });
  }
  get schema() {
    return this.args.composer.state.prosemirrorState.schema;
  }
  get state() {
    return this.args.composer.state;
  }
  disableComposerInteractivity() {
    this.args.composer.disableInteractivity();
  }
  enableComposerInteractivity() {
    this.args.composer.enableInteractivity();
  }
  generateFallbackBlocks() {
    if (!this.args.composer.config.singleBlockMode) {
      return null;
    }
    return [...this.args.composer.blocksDoc.blocks];
  }
  hideHtmlEditor() {
    this.isEditingHtml = false;
    this.enableComposerInteractivity();
  }
  insertIfElseStatement(block) {
    this.closeIfElseStatementInserter();
    this.trackAnalyticsEvent('ifElseStatement');
    if (this.args.composer.config.singleBlockMode) {
      this.args.composer.commands.replaceAllWithBlock(block);
    } else {
      this.args.composer.commands.insertBlock(block);
    }
    this.args.composer.commands.focus();
  }
  closeIfElseStatementInserter() {
    this.isInsertingIfElseStatement = false;
    this.args.composer.enableInteractivity();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isInsertingIfElseStatement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEditingHtml", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "disableComposerInteractivity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "disableComposerInteractivity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableComposerInteractivity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "enableComposerInteractivity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "generateFallbackBlocks", [action], Object.getOwnPropertyDescriptor(_class.prototype, "generateFallbackBlocks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideHtmlEditor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideHtmlEditor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertIfElseStatement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertIfElseStatement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeIfElseStatementInserter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeIfElseStatementInserter"), _class.prototype)), _class);
export { ExternalEditors as default };